/*专门给省份城市使用*/
define('services/mysetting/region.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('regionService', ['ngDialog', '$state', 'auiDialog','OpenUp', '$q', function (ngDialog, $state, auiDialog, OpenUp, $q) {
       var provicesList=[];
        //flag为true是给添加银行的时候用的，因为OpenDeveloper入库银行是 shortName
        function setProvince(callback,flag){
            var provices =[];
            // 目前最新要求从idata中获取数据，idata数据由opendeveloper封装
            OpenUp.getProvinceList({ req: {countryAlpha2Code : 'CN'}
            }).then(function (res) {
                var resultCode = res.resultCode;
                var provinceTemp = res.provinceList;
                provicesList =  res.provinceList;
                if(resultCode == 0 && provinceTemp){
                    for(var i in provinceTemp){
                        if(flag){
                            provices.push({'key':provinceTemp[i].name,'value':provinceTemp[i].shortNameCn});
                        }else{
                            provices.push({'key':provinceTemp[i].name,'value':provinceTemp[i].chineseName});
                        }
                    }
                    callback(provices);
                }
            }).catch(function(res){
                callback(provices);
            });
        }

        function setCity(province,callback){
            var cities = [];
            // 目前最新要求从idata中获取数据，idata数据由opendeveloper封装
            OpenUp.getCityList({ req:{provinceName : province}
            }).then(function (res) {
                var resultCode = res.resultCode;
                var citysTemp = res.cityList;
                if(resultCode == 0 && citysTemp){
                    for(var i in citysTemp){
                        cities.push({'key':citysTemp[i].name,'value':citysTemp[i].chineseName});
                    }
                    callback(cities);
                }
            }).catch(function(res){
                callback(cities);
            });
        }

        // 根据省份key和省份list，匹配到对应省份名称
        function getProvinceFromList(provinceKey,provinceList){
            // 如果省份key和省份list都有效，则循环list，获取到key对应的value。
            if (provinceKey && provinceList){
                for(var i in provinceList){
                    if (provinceList[i].key == provinceKey){
                        return provinceList[i].value;
                    }
                }
            }
            return provinceKey;
        }

        // 根据城市key和城市list，匹配到对应省份名称
        function getCityFromList(cityKey,cityList){
            // 如果城市key和城市list都有效，则循环list，获取到key对应的value。
            if (cityKey && cityList){
                for(var i in cityList){
                    if (cityList[i].key == cityKey){
                        return cityList[i].value;
                    }
                }
            }
            return cityKey;
        }

        // 根据省份key获取省份名称
        function getProvinceByName(provinceNameTemp,callback){
            // 目前最新要求从idata中获取数据，idata数据由opendeveloper封装
            OpenUp.getProvince({ req:{provinceName : provinceNameTemp}
            },true).then(function (res) {
                if (res.province){
                    callback(res.province.chineseName);
                }
                else{
                    callback();
                }
            }).catch(function(res){
                callback();
            });
        }

        // 根据城市key获取城市名称
        function getCityByName(cityNameTemp,callback){
            // 目前最新要求从idata中获取数据，idata数据由opendeveloper封装
            OpenUp.getCity({ req:{cityName : cityNameTemp}
            },true).then(function (res) {
                if(res.city){
                    callback(res.city.chineseName);
                }
                else{
                    callback();
                }

            }).catch(function(res){
                callback();
            });
        }



        function getProviceKeyByShortName(shortName) {
            var provinceTemp;
            if(provicesList.length>0){
                 provinceTemp = provicesList;
                for(var i in provinceTemp){
                    if(provinceTemp[i].shortNameCn == shortName){
                        return provinceTemp[i].name;
                    }
                }
            }else{
                OpenUp.getProvinceList({ req: {countryAlpha2Code : 'CN'}
                }).then(function (res) {
                    var resultCode = res.resultCode;
                    provicesList =  res.provinceList;
                    provinceTemp = res.provinceList;
                    if(resultCode == 0 && provinceTemp){
                        for(var i in provinceTemp){
                            if(provinceTemp[i].shortNameCn == shortName){
                                return provinceTemp[i].name;
                            }
                        }
                    }
                });
            }
            return shortName;
        }
        


        return {
            'setProvince' : setProvince,
            'setCity':setCity,
            'getProvinceFromList':getProvinceFromList,
            'getCityFromList':getCityFromList,
            'getProvinceByName':getProvinceByName,
            'getCityByName':getCityByName,
            'getProviceKeyByShortName':getProviceKeyByShortName
        }
    }]);
});

